function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSailpoint = function SvgSailpoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 109.5 107"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m63 0 13.2 78.6H0z",
    style: {
      fill: "#0033a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.9 0 46.7 78.6H76z",
    style: {
      fill: "#cc27b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 78.6h76.2L81 107z",
    style: {
      fill: "#0071ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 78.6h33.5L80.8 107z",
    style: {
      fill: "#e17fd2"
    }
  }));
};
export default SvgSailpoint;